import { createSlice } from '@reduxjs/toolkit';

type HblStatusState = {
  loading: boolean;
  filterSearchDetailData: any[];
  message: string;
  hblDetail: any[];
  hblDocDetail: any[];
  hblDocValidation: any;
  success: boolean;
};

const initialState: HblStatusState = {
  loading: false,
  filterSearchDetailData: [],
  message: '',
  hblDetail: [],
  hblDocDetail: [],
  hblDocValidation: {},
  success: false,
};

export const hblStatusSlice = createSlice({
  name: 'hblStatusExport',
  initialState,
  reducers: {
    filterHblDetail: (state, action) => {
      state.loading = true;
      state.message = '';
    },
    filterHblDetailSuccess: (state, action) => {
      state.loading = false;
      state.filterSearchDetailData = action.payload?.records;
      state.success = false;
    },
    filterHblFailure: (state) => {
      state.loading = false;
    },
    getDetailHblDoc: (state, action) => {
      state.loading = true;
    },
    getDetailHblDocSuccess: (state, action) => {
      state.loading = false;
      state.hblDocDetail = action.payload;
    },
    getDetailHblDocFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    uploadHblDoc: (state, action) => {},
    deleteHblDoc: (state, action) => {},
    getHblDocValidation: (state, action) => {
      state.loading = true;
      state.message = '';
    },
    getHblDocValidationSuccess: (state, action) => {
      state.loading = false;
      state.hblDocValidation = action.payload;
      state.success = false;
    },
    getHblDocValidationFailure: (state, action) => {
      state.loading = false;
    },
    cleanDataHbl: (state) => {
      state.hblDetail = [];
    },
  },
});

export const {
  filterHblDetail,
  filterHblDetailSuccess,
  filterHblFailure,
  getDetailHblDoc,
  getDetailHblDocSuccess,
  getDetailHblDocFailure,
  uploadHblDoc,
  deleteHblDoc,
  getHblDocValidation,
  getHblDocValidationSuccess,
  getHblDocValidationFailure,
  cleanDataHbl,
} = hblStatusSlice.actions;

export default hblStatusSlice.reducer;
